import { ref, nextTick } from "vue";

interface ToastOptions {
  message: string;
  type?: "success" | "error" | "info" | "warning";
  duration?: number;
}

const toasts = ref<Array<ToastOptions & { id: string }>>([]);

export function useToast() {
  const showToast = (options: ToastOptions) => {
    const toast = {
      ...options,
      id: Math.random().toString(36).substr(2, 9),
      type: options.type || "info",
      duration: options.duration || 4000,
    };

    toasts.value.push(toast);

    // Auto remove after duration
    setTimeout(() => {
      removeToast(toast.id);
    }, toast.duration);
  };

  const removeToast = (id: string) => {
    const index = toasts.value.findIndex((toast) => toast.id === id);
    if (index > -1) {
      toasts.value.splice(index, 1);
    }
  };

  const showSuccess = (message: string, duration?: number) => {
    showToast({ message, type: "success", duration });
  };

  const showError = (message: string, duration?: number) => {
    showToast({ message, type: "error", duration });
  };

  const showInfo = (message: string, duration?: number) => {
    showToast({ message, type: "info", duration });
  };

  const showWarning = (message: string, duration?: number) => {
    showToast({ message, type: "warning", duration });
  };

  return {
    toasts,
    showToast,
    removeToast,
    showSuccess,
    showError,
    showInfo,
    showWarning,
  };
}
